import { Button } from "@ui/Button";
import { Icon } from "@ui/Icon";
import { useAppContext } from "@ui/layouts/layoutProvider";
import { PlatformPickerDropdown } from "@ui/layouts/PlatformPickerDropdown";
import { pickerMode } from "@ui/layouts/pickerMode";
import { Pill } from "@ui/Pill";
import { HStack, Stack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";

type Props = {
	icon: string;
	smallIcon: string;
	releaseVersion?: "alpha" | "beta";
};

export const SidePanelHeader = (props: Props) => {
	const { menuIsOpen, setMenuIsOpen } = useAppContext();
	const buttonLabel = () => (menuIsOpen() ? "Collapse Menu" : "Expand Menu");
	const titleSpacing = () => (menuIsOpen() ? "large" : "none");
	const symbol = () => (menuIsOpen() ? "menu_open" : "menu");
	return (
		<Stack
			class=" header-stack"
			align="center"
			direction="row"
			spacing={titleSpacing()}
			justify="space-between"
		>
			<HStack align="center" spacing="medium">
				<Show
					when={pickerMode() === "slack"}
					fallback={
						<Show
							when={menuIsOpen()}
							fallback={
								<Icon
									icon={props.smallIcon}
									fillWithCurrentColor={false}
									class="collapsed-brand"
									display="inline-flex"
								/>
							}
						>
							<span class="brand-logo" innerHTML={props.icon} />
						</Show>
					}
				>
					<PlatformPickerDropdown
						wordmark={props.icon}
						mark={props.smallIcon}
						expanded={menuIsOpen()}
					/>
				</Show>
				<Show when={props.releaseVersion && menuIsOpen()}>
					<Pill size="xsmall" theme="primary" variant="filled">
						<Text
							transform="capitalize"
							size="xsmall"
							weight="bold"
							color="primary"
						>
							{props.releaseVersion}
						</Text>
					</Pill>
				</Show>
			</HStack>
			<Button
				variant="text"
				theme="monochrome"
				symbol={symbol()}
				symbolRelativeSize={2}
				class="menu-toggle-button"
				aria-label={buttonLabel()}
				onClick={() => setMenuIsOpen(!menuIsOpen())}
			/>
		</Stack>
	);
};
